import { render } from "./Learn.vue?vue&type=template&id=51938d83&scoped=true&bindings={}"
import script from "./Learn.vue?vue&type=script&lang=js"
export * from "./Learn.vue?vue&type=script&lang=js"

import "./Learn.vue?vue&type=style&index=0&id=51938d83&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51938d83"

export default script